import { gql } from "apollo-boost";

export const LoginQuery = gql`
query Login(
    $email: String!, 
    $password: String!
) {
    login(email: $email, password: $password) {
        userId
        name
        email
        token
        tokenExpiration
        refreshToken
        activeCompanyDetails {
            _id
        }
    }
}`;

export const RefreshToken = gql`
query refreshToken($refreshToken: String!){
    refreshToken(refreshToken: $refreshToken) {
      token
    }
}`;

export const RegisterQuery = gql`
mutation User($userInput: UserInput){
    createUser(userInput: $userInput) {
        # userId
        # name
        # email
        token
        # tokenExpiration
    }
}`;

export const ConfirmUser = gql`
mutation confirmUser($confirmationToken: String!) {
  confirmUser(confirmationToken :$confirmationToken){
        userId
        name
        email
        token
        tokenExpiration
        refreshToken
  }
}`;

export const ResendConfirmationToken = gql`
mutation resendConfirmationToken($email: String!) {
    resendConfirmationToken(email: $email)
}
`;

export const ResetPassword = gql`
mutation resetPassword($confirmationToken: String!, $newPassword: String!) {
    resetPassword(confirmationToken: $confirmationToken, newPassword: $newPassword)
}`;

export const GenerateResetPasswordToken = gql`
mutation generateResetPasswordToken($email: String!) {
    generateResetPasswordToken(email: $email)
}`;


export const CreateCompanyQuery = gql`
mutation createCompany($createCompanyData: AddCompanyInput) {
    createCompany(companyInput :$createCompanyData) {
        _id
        name
    }
}`;

export const CreateBusinessPartner = gql`
mutation createBusinessPartner($businessPartnerInput: BusinessPartnerInput) {
    createBusinessPartner(businessPartnerInput: $businessPartnerInput) {
        _id
        name
    }
}`;

export const UpdateBusinessPartner = gql`
mutation updateBusinessPartner($input: BusinessPartnerUpdateInput) {
    updateBusinessPartner(input: $input) {
        _id
        name
    }
}`;

export const GetProfileInfo = gql`
query getProfileInfo {
    getProfileInfo {
        userId
        name
        email
        companyName
        companyPhone
        gstnNumber
        membershipStatus
    }
}`;

export const GetAllConsignee = gql`
query getAllConsignees($companyId: ID!){
    getAllConsignees(companyId: $companyId) {
        _id
        name
        address
        country
        email
        phoneNumber
        partnerType
        bankDetails {
            bankName
            address
            swiftCode
            acNumber
            accountName
        }
    }
}`;

export const GetAllBusinessPartners = gql`
query getAllBusinessPartners($companyId: ID!){
    getAllBusinessPartners(companyId: $companyId) {
        _id
        name
        address
        country
        email
        phoneNumber
        partnerType
        bankDetails {
            _id
            bankName
            address
            swiftCode
            acNumber
            accountName
        }
    }
}`;

export const GetAllSuppliers = gql`
query getAllSuppliers($companyId: ID!){
    getAllSuppliers(companyId: $companyId) {
        _id
        name
        address
        country
        email
        phoneNumber
        partnerType
        bankDetails {
            _id
            bankName
            address
            swiftCode
            acNumber
            accountName
        }
    }
}
`;


export const DeleteBusinessPartner = gql`
mutation deleteBusinessPartner($businessPartnerId: ID!, $companyId: ID!) {
    deleteBusinessPartner(businessPartnerId: $businessPartnerId, companyId: $companyId){
    companyId
    message
  }
}
`;

export const GetCompanyAllBanks = gql`
query getCompanyAllBanks($companyId: ID!){
    getCompanyAllBanks(companyId: $companyId) {
        _id
        bankName
        address
        swiftCode
        acNumber
        accountName
    }
}`;

export const GetAllCountries = gql`
query GetAllCountries($companyId: ID!){
    getAllCountries(companyId: $companyId) {
        _id
        country
    }
}`;

export const DeleteCompanyBank = gql`
mutation deleteCompanyBank($deleteCompanyBankInput: DeleteCompanyBankInput) {
  deleteCompanyBank(deleteCompanyBankInput: $deleteCompanyBankInput ){
    companyId
    message
  }
}
`;

export const GetAllDeliveryTerms = gql`
query GetAllDeliveryTerms($companyId: ID!) {
    getAllDeliveryTerms(companyId: $companyId) {
        _id
        deliveryTerm
    }
}`;

export const GetAllPackingTypes = gql` 
query GetAllPackingTypes($companyId: ID!){
    getAllPackingTypes(companyId: $companyId) {
        _id
        packingType
    }
}`;

export const GetAllPaymentTerms = gql`
query GetAllPaymentTerms($companyId: ID!){
    getAllPaymentTerms(companyId: $companyId) {
        _id
        paymentTerm
    }
}`;

export const GetAllPorts = gql`
query getAllPorts($companyId: ID!) {
    getAllPorts(companyId: $companyId) {
        _id
        port 
        country
    }
}`;

export const GetAllProductNames = gql`
query GetAllProductNames($companyId: ID!){
    getAllProductNames(companyId: $companyId) {
        _id
        productName
        productType
        hsCode
        unitType
    }
}`;


export const GetAllShippingModes = gql`
query GetAllShippingModes($companyId: ID!) {
    getAllShippingModes(companyId: $companyId) {
        _id
        shippingMode
    }
}`;

export const getAllMasterArrayData = gql`
query GetMasterData(
    $companyId: ID!
) {
  getMasterData(companyId: $companyId) {
    _id,
    deliveryTerms {
      _id
      terms
    },
    ports {
      _id
      ports
    },
    packingTypes {
      _id
      packingTypes
    },
    paymentTerms{
      _id
      paymentTerms
    },
    productNames {
      _id
      products {
        productName
        hsCode
      }
    }
    shippingModes {
      _id
      shippingModes
    },
    countries {
      _id
      countries
    }
  }
}
`;

export const GetProformaLists = gql`
query GetMasterData(
    $companyId: ID!
) {
  getMasterData(companyId: $companyId) {
      _id,
      pfis{
        _id
        invoiceNumber
        date
       consignee {
        name
      }
      }
    }
  }`;

export const AddCompanyBankDetailsQuery = gql`
mutation addCompanyBankDetails($bankInput: CompanyBankInput!) {
    addCompanyBankDetails(bankInput: $bankInput) {
      _id
    }
}`;


export const UpdateCompanyBankDetails = gql`
mutation updateCompanyBankDetails($updateCompanyBankInput: UpdateCompanyBankInput!){
    updateCompanyBankDetails(updateCompanyBankInput: $updateCompanyBankInput) {
      _id
    }
  }
`;

export const AddBusinessPartnerBankDetails = gql`
mutation addBusinessPartnerBankDetails($bankInput: BusinessPartnerBankInput!) {
    addBusinessPartnerBankDetails(bankInput: $bankInput) {
        _id
        bankName
    }
}`;

export const UpdateBusinessPartnerBankDetails = gql`
mutation updateBusinessPartnerBankDetails($updateBusinessPartnerBankInput: UpdateBusinessPartnerBankInput!){
    updateBusinessPartnerBankDetails(updateBusinessPartnerBankInput: $updateBusinessPartnerBankInput) {
      _id
    }
  }
`;

export const AddCountry = gql`
mutation addCountry($countryInput: CountryInput) {
    addCountry(countryInput: $countryInput) {
        _id
        country
    }
}`;

export const AddDeliveryTerm = gql`
mutation addDeliveryTerm($deliveryTermInput: DeliveryTermInput) {
    addDeliveryTerm(deliveryTermInput: $deliveryTermInput) {
        _id
        deliveryTerm
    }
}`;
export const AddPackingType = gql`
mutation addPackingType($packingTypeInput: PackingTypeInput) {
    addPackingType(packingTypeInput: $packingTypeInput) {
        _id
        packingType
    }
}`;
export const AddPaymentTerm = gql`
mutation addPaymentTerm($paymentTermInput: PaymentTermInput) {
    addPaymentTerm(paymentTermInput: $paymentTermInput) {
        _id
        paymentTerm
    }
}`;
export const AddPort = gql`
mutation addPort($portInput: PortInput) {
    addPort(portInput: $portInput) {
        _id
        port
        country
    }
}`;

export const AddProductName = gql`
mutation addProductName($productNameInput: ProductNameInput) {
    addProductName(productNameInput: $productNameInput) {
        _id
        productName
        productType
        hsCode
        unitType
    }
}`;

export const AddShippingMode = gql`
mutation addShippingMode($shippingModeInput: ShippingModeInput) {
    addShippingMode(shippingModeInput: $shippingModeInput) {
        _id
        shippingMode
    }
}`;

export const DeleteDeliveryTerm = gql`
mutation deleteDeliveryTerm($deleteDeliveryTermInput: DeleteDeliveryTermInput) {
    deleteDeliveryTerm(deleteDeliveryTermInput: $deleteDeliveryTermInput) {
        companyId
        statusCode
        message
    }
}`;

export const DeletePaymentTerm = gql`
mutation deletePaymentTerm($deletePaymentTermInput: DeletePaymentTermInput) {
    deletePaymentTerm(deletePaymentTermInput: $deletePaymentTermInput) {
        companyId
        message
        statusCode
  }
}`;

export const DeleteShippingMode = gql`
mutation deleteShippingMode($deleteShippingModeInput: DeleteShippingModeInput) {
    deleteShippingMode(deleteShippingModeInput: $deleteShippingModeInput) {
        companyId
        statusCode
        message
    }
}`;

export const DeleteProductName = gql`
mutation deleteProductName($deleteProductNameInput: DeleteProductNameInput) {
    deleteProductName(deleteProductNameInput: $deleteProductNameInput) {
        companyId
        statusCode
        message
    }
}`;

export const DeletePackingType = gql`
mutation deletePackingType($deletePackingTypeInput: DeletePackingTypeInput) {
    deletePackingType(deletePackingTypeInput: $deletePackingTypeInput) {
        companyId
        statusCode
        message
    }
}`;

export const DeletePort = gql`
mutation deletePort($deletePortInput: DeletePortInput) {
    deletePort(deletePortInput: $deletePortInput) {
        companyId
        statusCode
        message
    }
}`;

export const DeleteCountry = gql`
mutation deleteCountry($deleteCountryInput: DeleteCountryInput) {
    deleteCountry(deleteCountryInput: $deleteCountryInput) {
        companyId
        statusCode
        message
    }
}`;

export const UpdateCountry = gql`
mutation updateCountry($updateCountryInput: UpdateCountryInput) {
    updateCountry(updateCountryInput: $updateCountryInput) {
        _id
        country
  }
}`;

export const UpdatePort = gql`
mutation updatePort($updatePortInput: UpdatePortInput) {
    updatePort(updatePortInput: $updatePortInput) {
        _id
        port
        country
  }
}`;


export const UpdateDeliveryTerm = gql`
mutation updateDeliveryTerm($updateDeliveryTermInput: UpdateDeliveryTermInput) {
    updateDeliveryTerm(updateDeliveryTermInput: $updateDeliveryTermInput) {
        _id
        deliveryTerm
  }
}`;

export const UpdatePaymentTerm = gql`
mutation updatePaymentTerm($updatePaymentTermInput: UpdatePaymentTermInput) {
    updatePaymentTerm(updatePaymentTermInput: $updatePaymentTermInput) {
        _id
        paymentTerm
  }
}`;

export const UpdateShippingMode = gql`
mutation updateShippingMode($updateShippingModeInput: UpdateShippingModeInput) {
    updateShippingMode(updateShippingModeInput: $updateShippingModeInput) {
        _id
        shippingMode
  }
}`;

export const UpdatePackingType = gql`
mutation updatePackingType($updatePackingTypeInput: UpdatePackingTypeInput) {
    updatePackingType(updatePackingTypeInput: $updatePackingTypeInput) {
        _id
        packingType
  }
}`;

export const UpdateProductName = gql`
mutation updateProductName($updateProductNameInput: UpdateProductNameInput)  {
    updateProductName(updateProductNameInput: $updateProductNameInput)  {
        _id
        productName
        productType
        hsCode
        unitType
  }
}`;


export const GetAllPfiList = gql`
query getAllPFIs($companyId: ID!) {
    getAllPFIs(companyId: $companyId){
        _id
        invoiceNumber
        date
        customerPoNumber
        customerPoDate
        businessPartner {
            _id
            name
            address
            email
            phoneNumber
        }
        buyer {
            name
            address
        }
        paymentTerms {
            _id
            paymentTerm
        }
        deliverySchedule
        deliveryTerms {
            _id
            deliveryTerm
        }
        shippingMode {
            _id
            shippingMode
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        countryOfOrigin {
            _id
            country
        }
        finalDestination {
            _id
            country
        }
        countryOfDestination {
            _id
            country
        }
        portOfDischarge {
            _id
            port
            country
        }
        portOfDestination {
            _id
            port
            country
        }
        pfiItemDetails{
            descriptionOfGoods {
                _id
                productName
                productType
                hsCode
                unitType
            }
            packingTypes {
                _id
                packingType
            }
            quantity
            unitType 
            comments
            noOfPackages
            rate
            amount
        }
        totalQuantity
        totalAmount
        bankDetails {
            _id
            bankName
            address
            swiftCode
            acNumber
            accountName
        }
        breakUpAmount {
            cfbPrice
            lessFreight
            lessInsurance
            totalFobPrice
        }
        termsAndConditions
        currency
        isDeleted
        updatedAt
        reasonToDelete
    }
}`;

export const CreateNewPFI = gql`
mutation createNewPFI($pfiInput: PFIInput) {
    createNewPFI(pfiInput: $pfiInput) {
        _id
    }
}`;

export const UpdatePFI = gql`
mutation updatePFI($pfiId: ID!,$companyId: ID!, $input: PFIUpdateInput) {
    updatePFI(pfiId: $pfiId,companyId: $companyId, input: $input) {
      _id
    }
}`;


export const DeletePFI = gql`
mutation deletePFI($pfiId: ID!, $companyId: ID!, $reasonToDelete: String) {
    deletePFI(pfiId: $pfiId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        companyId
        message
    }
}
`;


export const GetAllPreShipmentInvoices = gql`
query getAllPreShipmentInvoices($companyId: ID!) {
    getAllPreShipmentInvoices(companyId: $companyId){
        _id
        invoiceNumber
        date
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        exporterRefNo {
            _id
            invoiceNumber
        }
        buyer {
            name
            address
        }
        paymentTerms {
            _id
            paymentTerm
        }
        scheduledDelivery
        deliveryTerms {
            _id
            deliveryTerm
        }
        methodOfDispatch {
            _id
            shippingMode
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        countryOfOrigin {
            _id
            country
        }
        countryOfDestination {
            _id
            country
        }
        finalDestination {
            _id
            country
        }
        portOfDischarge {
            _id
            port
            country
        }
        pfiItemDetails{
            descriptionOfGoods {
                _id
                productName
                productType
                hsCode
                unitType
            }
            packingTypes {
                _id
                packingType
            }
            unitType 
            noOfPackages
            quantity
            rate
            amount
            comments
        }
        totalQuantity
        totalAmount
        manufactureDetails
        gstSchema
        gstMessage
        containerNo
        sealNo
        customerPoNumber
        customerPoDate
        # bankDetails {
        #     _id
        #     bankName
        #     address
        #     swiftCode
        #     acNumber
        #     accountName
        # }
        breakUpAmount {
            cfrValue
            freight
            fobValue
            exchangeRate
            fobValueInInr
            commission
            insurance
        }
        shipmentUnderDutyDrawback
        tarriffRate
        termsAndConditions
        declaration
        currency
        isDeleted
        updatedAt
        reasonToDelete
    }
}`;

export const CreatePreShipmentInvoice = gql`
mutation createPreShipmentInvoice($preShipmentInvoiceInput: PSIInput) {
    createPreShipmentInvoice(preShipmentInvoiceInput: $preShipmentInvoiceInput) {
        _id
    }
}`;

export const UpdatePreShipmentInvoice = gql`
mutation updatePreShipmentInvoice($psiId: ID!,$companyId: ID!, $input: PSIUpdateInput) {
    updatePreShipmentInvoice(psiId: $psiId,companyId: $companyId, input: $input) {
      _id
    }
}`;


export const DeletePreShipmentInvoice = gql`
mutation deletePreShipmentInvoice(
    $psiId: ID!,
    $companyId: ID!,
    $reasonToDelete: String
) {
    deletePreShipmentInvoice(psiId: $psiId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        message
    }
}
`;


export const createPackingList = gql`
mutation createPackingList($packingListInput: PackingListInput) {
    createPackingList(packingListInput: $packingListInput) {
      _id
    }
}`;

export const UpdatePackingList = gql`
mutation updatePackingList($packingListId: ID!, $input: PackingListUpdateInput, $companyId: ID!) {
    updatePackingList(packingListId: $packingListId, input: $input, companyId: $companyId) {
      _id
    }
}`;


export const DeletePackingList = gql`
mutation deletePackingList($packingListId: ID!, $companyId: ID!, $reasonToDelete: String) {
    deletePackingList( packingListId: $packingListId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        message
    }
}
`;

export const GetAllPackingLists = gql`
query getAllPackingLists($companyId: ID!) {
    getAllPackingLists(companyId: $companyId){
        _id
        invoiceNumber
        date
        customerPoNumber
        exporterRefNo {
            _id
            invoiceNumber
        }
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        buyer {
            name
            address
        }
        methodOfDispatch {
            _id
            shippingMode
        }
        countryOfOrigin {
            _id 
            country
        }
        countryOfDestination {
            _id 
            country
        }
        finalDestination {
            _id
            country
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        portOfDischarge {
            _id
            port
            country
        }
        manufactureDetails
        totalQuantity
        packingListItemDetails {
            descriptionOfGoods {
                _id
                productName
            }
            packingTypes {
                _id
                packingType
            }
            quantity
            noOfPackages
            unitType
            netWeight
            tareWeight
            totalGrossWeight
            noOfPallets
            weightOfPallet
        }
        breakUpWeight {
            netWeightPerPackage
            grossWeightPerPackage
            tareWeightPerPackage
        }
        # declaration
        containerNo
        sealNo
        termsAndConditions
        # note
        totalAmount
        isDeleted
        updatedAt
        reasonToDelete
    }
}`;



export const CreatePurchaseOrder = gql`
mutation createPurchaseOrder($purchaseOrderInput: PurchaseOrderInput) {
    createPurchaseOrder(purchaseOrderInput: $purchaseOrderInput) {
      _id
    }
}`;

export const UpdatePurchaseOrder = gql`
mutation updatePurchaseOrder($purchaseOrderId: ID!, $input: PurchaseOrderUpdateInput, $companyId: ID!) {
    updatePurchaseOrder(purchaseOrderId: $purchaseOrderId, input: $input, companyId: $companyId) {
      _id
    }
}`;


export const DeletePurchaseOrder = gql`
mutation deletePurchaseOrder($purchaseOrderId: ID!, $companyId: ID!, $reasonToDelete: String) {
    deletePurchaseOrder( purchaseOrderId: $purchaseOrderId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        message
    }
}
`;

export const GetAllPurchaseOrders = gql`
query getAllPurchaseOrders($companyId: ID!) {
    getAllPurchaseOrders(companyId: $companyId) {
        _id
        invoiceNumber {
            _id
            invoiceNumber
        }
        poNumber
        # belongsTo
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        shipTo {
            name
            address
        }
        poDate
        paymentTerms {
            _id
            paymentTerm
        }
        shippedVia {
            _id
            shippingMode
        }
        fobPoint
        deliveryTerms {
            _id
            deliveryTerm
        }
        purchaseOrderItemDetails {
            quantityInMt
            descriptionOfGoods {
                _id
                productName
            }
            packingTypes {
                _id
                packingType
            }
            unitQuantity
            # unitType
            priceInInr
            amount
        }
        currency
        gstBracket
        gstNotification
        consignmentTotalQuantity
        amountTotalInInr
        grandTotal
        # declaration
        additionalTermsAndConditions
        isDeleted
        updatedAt
        reasonToDelete
    }
}`;


export const CreateNewCommercialInvoice = gql`
mutation createNewCommercialInvoice($commercialInvoiceInput: CommercialInvoiceInput) {
    createNewCommercialInvoice(commercialInvoiceInput: $commercialInvoiceInput) {
      _id
    }
}`;

export const UpdateCommercialInvoice = gql`
mutation updateCommercialInvoice($commercialInvoiceId: ID!, $input: CommercialInvoiceUpdateInput, $companyId: ID!) {
    updateCommercialInvoice(commercialInvoiceId: $commercialInvoiceId, input: $input, companyId: $companyId) {
      _id
    }
}`;


export const DeleteCommercialInvoice = gql`
mutation deleteCommercialInvoice($commercialInvoiceId: ID!, $companyId: ID!, $reasonToDelete: String) {
    deleteCommercialInvoice( commercialInvoiceId: $commercialInvoiceId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        message
    }
}
`;

export const GetAllCommercialInvoices = gql`
query getAllCommercialInvoices($companyId: ID!) {
    getAllCommercialInvoices(companyId: $companyId) {
        _id
        invoiceNumber
        invoiceDate
        exporterRefNo {
            _id
            invoiceNumber
        }
        otherReferences {
            _id
            invoiceNumber
        }
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        buyer {
            name
            address
        }
        poNumber {
            _id
            poNumber
        }
        methodOfDispatch {
            _id
            shippingMode
        }
        countryOfOrigin {
            _id 
            country
        }
        finalDestination {
            _id
            country
        }
        countryOfDestination {
            _id 
            country
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        portOfDestination {
            _id
            port
            country
        }
        
        scheduledDelivery
        currency
        paymentTerms {
            _id
            paymentTerm
        }
        deliveryTerms {
            _id
            deliveryTerm
        }
        commercialInvoiceItemDetails {
            descriptionOfGoods {
                _id
                productName
                hsCode
            }
            packingTypes {
                _id
                packingType
            }
            unitQuantity
            unitType
            price
            amount
            comments
        }
        consignmentTotalQuantity
        amountTotal
        billOfLadingNo
        date
        containerNo
        sealNo
        customerPoNumber
        customerPoDate
        breakUpAmount {
            cfbPrice
            lessFreight
            lessInsurance
            totalFobPrice
        }
        bankDetails {
            _id
            bankName
            address
            swiftCode
            acNumber
            accountName
        }
        termsAndConditions
        declaration
        isDeleted
        reasonToDelete
        updatedAt
    }
}`;


export const GetAllPsiInvoices = gql`
query getAllPreShipmentInvoices($companyId: ID!) {
    getAllPreShipmentInvoices(companyId: $companyId){
        _id
        invoiceNumber
        date
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        exporterRefNo {
            _id
            invoiceNumber
        }
        buyer {
            name
            address
        }
        paymentTerms {
            _id
            paymentTerm
        }
        scheduledDelivery
        deliveryTerms {
            _id
            deliveryTerm
        }
        methodOfDispatch {
            _id
            shippingMode
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        countryOfOrigin {
            _id
            country
        }
        countryOfDestination {
            _id
            country
        }
        finalDestination {
            _id
            country
        }
        portOfDischarge {
            _id
            port
            country
        }
        pfiItemDetails{
            descriptionOfGoods {
                _id
                productName
                productType
                hsCode
                unitType
            }
            packingTypes {
                _id
                packingType
            }
            unitType 
            quantity
            rate
            amount
            comments
        }
        totalQuantity
        totalAmount
        manufactureDetails
        gstSchema
        gstMessage
        containerNo
        sealNo
        customerPoNumber
        customerPoDate
        # bankDetails {
        #     _id
        #     bankName
        #     address
        #     swiftCode
        #     acNumber
        #     accountName
        # }
        breakUpAmount {
            cfrValue
            freight
            fobValue
            exchangeRate
            fobValueInInr
            commission
            insurance
        }
        shipmentUnderDutyDrawback
        tarriffRate
        termsAndConditions
        declaration
        currency
        isDeleted
        updatedAt
    }
  }
`;

export const GetAllPOInvoices = gql`
query getAllPurchaseOrders($companyId: ID!) {
    getAllPurchaseOrders(companyId: $companyId) {
        _id
        poNumber
        isDeleted
        # invoiceNumber
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        shipTo {
            name
            address
        }
    }
}`;



export const CreateFinalPackingList = gql`
mutation createFinalPackingList($packingListInput: FinalPackingListInput) {
    createFinalPackingList(packingListInput: $packingListInput) {
      _id
    }
}`;

export const UpdateFinalPackingList = gql`
mutation updateFinalPackingList($packingListId: ID!, $input: FinalPackingListUpdateInput, $companyId: ID!) {
    updateFinalPackingList(packingListId: $packingListId, input: $input, companyId: $companyId) {
      _id
    }
}`;


export const DeleteFinalPackingList = gql`
mutation deleteFinalPackingList($packingListId: ID!, $companyId: ID!, $reasonToDelete: String) {
    deleteFinalPackingList( packingListId: $packingListId, companyId: $companyId, reasonToDelete: $reasonToDelete) {
        message
    }
}
`;

export const GetAllFinalPackingLists = gql`
query getAllFinalPackingLists($companyId: ID!) {
    getAllFinalPackingLists(companyId: $companyId){
        _id
        invoiceNumber
        date
        customerPoNumber
        exporterRefNo {
            _id
            invoiceNumber
        }
        businessPartnerId {
            _id
            name
            address
            email
            phoneNumber
        }
        methodOfDispatch {
            _id
            shippingMode
        }
        countryOfOrigin {
            _id 
            country
        }
        countryOfDestination {
            _id 
            country
        }
        finalDestination {
            _id
            country
        }
        vesselNo
        portOfLoading {
            _id
            port
            country
        }
        portOfDischarge {
            _id
            port
            country
        }
        totalQuantity
        packingListItemDetails {
            descriptionOfGoods {
                _id
                productName
            }
            packingTypes {
                _id
                packingType
            }
            quantity
            noOfPackages
            unitType
            netWeight
            tareWeight
            totalGrossWeight
            noOfPallets
            weightOfPallet
        }
        breakUpWeight {
            netWeightPerPackage
            grossWeightPerPackage
            tareWeightPerPackage
        }
        # declaration
        termsAndConditions
        # note
        totalAmount
        isDeleted
        updatedAt
        containerNo
        sealNo
        reasonToDelete
    }
}`;

export const GetIncrementedPfiNumber = gql`
query getIncrementedPfiNumber($companyId: ID!) {
    getIncrementedPfiNumber(companyId: $companyId)
}`;

export const GetIncrementedPsiNumber = gql`
query getIncrementedPsiNumber($companyId: ID!) {
    getIncrementedPsiNumber(companyId: $companyId)
}`;

export const GetIncrementedPlNumber = gql`
query getIncrementedPlNumber($companyId: ID!) {
    getIncrementedPlNumber(companyId: $companyId)
}`;

export const GetIncrementedFplNumber = gql`
query getIncrementedFplNumber($companyId: ID!) {
    getIncrementedFplNumber(companyId: $companyId)
}`;

export const GetIncrementedPoNumber = gql`
query getIncrementedPoNumber($companyId: ID!) {
    getIncrementedPoNumber(companyId: $companyId)
}`;

export const GetIncrementedCiNumber = gql`
query getIncrementedCiNumber($companyId: ID!) {
    getIncrementedCiNumber(companyId: $companyId)
}`;
